import { Component, OnInit, Signal, effect, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UntypedFormGroup, UntypedFormControl, ReactiveFormsModule, Validators, FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute, RouterModule } from '@angular/router';
import { AuthService } from '../../auth.service';
import { environment } from '../../../../environments/environment';
import { TuiInputModule } from '@taiga-ui/legacy';
import { TuiButton, TuiLoader, TuiTextfield } from '@taiga-ui/core';
import { signalSlice } from 'ngxtension/signal-slice';
import {formValues} from 'app/shared/utils/form.utils';
import { Observable, switchMap, map, startWith, catchError, of } from 'rxjs';



@Component({
    selector: 'app-login',
    imports: [CommonModule, ReactiveFormsModule, RouterModule, TuiInputModule, TuiTextfield, TuiButton, TuiLoader],
    templateUrl: './login.component.html',
    styleUrl: './login.component.css'
})
export class LoginComponent {
  public version: string = '1.2.3-dev.20230904';

  private readonly authService:AuthService = inject(AuthService);

  private fb = inject(FormBuilder);

  form = this.fb.nonNullable.group({
    email: ['', [Validators.required,Validators.email]],
    password: ['', Validators.required],
  });

  initialFormState = {
    ...this.form.getRawValue(),
    status: 'loading' as 'loading' | 'loaded' | 'submitting' | 'success' | 'error',
    errorMessage: ''
  };

  formState = signalSlice({
    initialState: this.initialFormState,
    sources: [formValues(this.form)],
    actionSources: {
      submit: (state, action$: Observable<void>) =>
        action$.pipe(
          switchMap(() =>
            this.authService.login(this.form.getRawValue()).pipe(
              map(() => ({ status: 'success' as const })),
              startWith({ status: 'submitting' as const }),
              catchError((error) => {
                return of({ status: 'error' as const, errorMessage: error });
              })
            )
          )
        ),
    },
  });


  constructor(private router:Router, private route:ActivatedRoute) {

    this.version = environment.version;

    effect(() => {
      const status = this.formState.status();

      if(status == 'success')
        this.router.navigate(['']);
    })
  }

  onSubmit(): void {
  }


}
